  let itemList2 = [

      {
        year: "2022",
        data:[
            {
                id: "2006",
                itemName: "2022年，江苏、湖南、河南三省建立起基本覆盖全省的干、支线自有物流网络。",
                itemTime: "2022",
                itemImage: "https://picture.hwason.cn/image/jpg/412774282333627520.jpg",
                remarK: '',
                itemYear: "2022"
              },
            {
                id: "2001",
                itemName: "2022年3月起，江河华晟医学旗下实验室全面投身于南京、长沙、郑州、上海的大规模新冠核酸检测战疫。",
                itemTime: "2022-03",
                itemImage: "https://picture.hwason.cn/image/jpg/412768079884955136.jpg",
                remarK: '',
                itemYear: "2022"
              }, 
              {
                id: "2002",
                itemName: "江河华晟启动公卫体检项目。",
                itemTime: "2022-05",
                itemImage: "https://picture.hwason.cn/image/jpg/412773429065395712.jpg",
                remarK: '',
                itemYear: "2022"
              }, 
              {
                id: "2003",
                itemName: "2022年6月，江河华晟医学成功入库“科技型中小企业”。",
                itemTime: "2022-06",
                itemImage: "https://picture.hwason.cn/image/png/412773640395400320.png",
                remarK: '',
                itemYear: "2022"
              },
              {
                id: "2004",
                itemName: "2022年8月，南京江河华晟医学科技有限公司成功入选南京市培育独角兽企业榜单。",
                itemTime: "2022-08",
                itemImage: "https://picture.hwason.cn/image/jpg/412773837691267904.jpg",
                remarK: '',
                itemYear: "2022"
              },
              {
                id: "2005",
                itemName: "2022年9月江河华晟医学和硕世生物联合举办“2022年宫颈癌筛查与诊治学术会议”。",
                itemTime: "2022-09",
                itemImage: "https://picture.hwason.cn/image/jpg/412774018709039936.jpg",
                remarK: '',
                itemYear: "2022"
              },
              
              {
                id: "2007",
                itemName: "12月12日，南京江河华晟被评定为高新技术企业。",
                itemTime: "2022-12",
                itemImage: "https://picture.hwason.cn/image/jpg/412774487363791680.jpg",
                remarK: '',
                itemYear: "2022"
              },          
        ]
      }, 
      {
        year: "2023",
        data:[
            {
                id: "3001",
                itemName: "江河华晟医学2023年公卫项目启动，累计完成公卫体检逾百万人次。",
                itemTime: "2023-02",
                itemImage: "https://picture.hwason.cn/image/jpg/412769952310338944.jpg",
                remarK: '',
                itemYear: "2023"
              },
              {
                id: "3002",
                itemName: "2023南京市医学检验实验室质量安全管理学术沙龙。",
                itemTime: "2023-05",
                itemImage: "https://picture.hwason.cn/image/jpg/412770280971806080.jpg",
                remarK: '',
                itemYear: "2023"
              },
              {
                id: "3003",
                itemName: "长沙江河华晟入选清廉企业示范点。",
                itemTime: "2023-05",
                itemImage: "https://picture.hwason.cn/image/jpg/412770431627012928.jpg",
                remarK: '',
                itemYear: "2023"
              }, 
              {
                id: "3004",
                itemName: "南京江河华晟医学检验实验室有限公司收到由中国合格评定国家认可委员会(CNAS)颁布的ISO15189实验室认可证书。",
                itemTime: "2023-08",
                itemImage: "https://picture.hwason.cn/image/jpg/412770781629099520.jpg",
                remarK: '',
                itemYear: "2023"
              }, 
              {
                id: "3005",
                itemName: "长沙江河华晟被评定为高新技术企业。",
                itemTime: "2023-10",
                itemImage: "https://picture.hwason.cn/image/jpg/412770921140038464.jpg",
                remarK: '',
                itemYear: "2023"
              },       
              {
                id: "3006",
                itemName: "南京江河华晟入选2023年度南京市培育独角兽企业榜单。",
                itemTime: "2023-12",
                itemImage: "https://picture.hwason.cn/image/jpg/412773837691267904.jpg",
                remarK: '',
                itemYear: "2023"
              },                            
        ]
      }, 
]

export default  itemList2








// WEBPACK FOOTER //
// ./src/components/website/aboutUs/component/newdata.js